import { render, staticRenderFns } from "./AdminCUDialog.vue?vue&type=template&id=35e59679&scoped=true"
import script from "./AdminCUDialog.vue?vue&type=script&lang=js"
export * from "./AdminCUDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e59679",
  null
  
)

export default component.exports